var map = {
	"./img_ghost_01@3x.png": "36fa",
	"./img_ghost_02@3x.png": "c5aa",
	"./img_ghost_03@3x.png": "68f9",
	"./img_ghost_04@3x.png": "7b78",
	"./img_ghost_05@3x.png": "50a8",
	"./img_ghost_06@3x.png": "5189",
	"./img_ghost_07@3x.png": "7a2d",
	"./img_ghost_08@3x.png": "1e5a",
	"./img_ghost_09@3x.png": "90bd",
	"./img_ghost_10@3x.png": "b986",
	"./img_ghost_11@3x.png": "c274",
	"./img_ghost_12@3x.png": "473c",
	"./img_ghost_13@3x.png": "002b",
	"./img_ghost_14@3x.png": "563e",
	"./img_ghost_15@3x.png": "1de2",
	"./img_ghost_16@3x.png": "827f",
	"./img_ghost_17@3x.png": "b588",
	"./img_ghost_18@3x.png": "16f4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "049c";